import { render, staticRenderFns } from "./QCreateLeadReferral.vue?vue&type=template&id=58bea806&scoped=true&"
import script from "./QCreateLeadReferral.vue?vue&type=script&lang=js&"
export * from "./QCreateLeadReferral.vue?vue&type=script&lang=js&"
import style0 from "./QCreateLeadReferral.vue?vue&type=style&index=0&id=58bea806&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bea806",
  null
  
)

export default component.exports